import * as yup from 'yup';
import type { FileUploadItem } from '@gov-nx/core/hooks';
import type { FormFileUploadProps } from '@gov-nx/ui/types';

interface FileUploadFieldProps {
	name: string;
	label: string;
	isExpanded?: boolean;
}

export interface FileUploadDefinition {
	defaultValue: FileUploadItem[];
	schema: yup.ArraySchema<
		FileUploadItem[] | undefined,
		yup.AnyObject,
		FileUploadItem[],
		'd'
	>;
	field: FormFileUploadProps;
}

export const useFileUploadDefinition = (
	props: FileUploadFieldProps
): FileUploadDefinition => {
	const schema = yup.array<FileUploadItem>().optional().default([]);
	return {
		defaultValue: [],
		schema,
		field: {
			field: { name: props.name, expanded: props.isExpanded },
			label: {
				children: props.label,
			},
		},
	};
};
